import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Loading from '../Loading/Loading.jsx'
import globalConfig from 'Helper/configHelpers'
import { useDispatch } from 'react-redux'
import { xtractAPI } from 'actions/apiActions'

const HelpModal = props => {
  const dispatch = useDispatch()
  const [apiVersion, setApiVersion] = useState(null)
  const [speed, setSpeed] = useState(null)

  useEffect(() => {
    const callbacks = {
      200: result => {
        const system = result.data.data.system
        setApiVersion(system.api_version)
      }
    }
    const speed = navigator?.connection?.downlink
    const speedString = speed ? `${speed} Mb/s` : '-'
    setSpeed(speedString)
    dispatch(xtractAPI('system', 'read', null, callbacks))
  }, [])

  function appInfo() {
    if (!apiVersion) {
      return (<Loading/>)
    } else {
      return (
        <>
          <div id="app-info">
            <b>Summit version:</b> {globalConfig.version}
            <br />
            <b>API version:</b> {apiVersion}
            <br />
            <b>Connection:</b> {speed}
          </div>
          <br />© Xtract Solutions
        </>
      )
    }
  }

  return (
    <div className="about-modal-container">
      {appInfo()}
    </div>
  )
}

HelpModal.propTypes = {
  closeSelf: PropTypes.func
}

export default HelpModal
